export default __webpack_public_path__ + "static/media/StoreOnIcon.aeb7f156.svg";